module.exports = "/images/sy.svg?820f5df4d6958379bbdf4ebe6dead663";